export default "__VITE_ASSET__6ccdc500__"